export default __webpack_public_path__ + "static/media/transportation-2-dk.2ef0edb3.svg";